export enum FancyColorSubgradeType {
  ColorStrength = 'colorStrength',
  Uniformity = 'uniformity',
}
